<template>
    <div class="session__show_feedback">
        <div
            class="column"
            v-for="(feedback, index) in sessionFeedbacks"
            :key="index"
        >
            <session-show-feedback-item
                :session="feedback"
                :trainer-id="index"
            />
        </div>
    </div>
</template>

<script>
import SessionShowFeedbackItem from './SessionShowFeedbackItem'

export default {
  components: { SessionShowFeedbackItem },
  name: 'session-show-feedback',
  computed: {
    sessionFeedbacks () {
      return this.$store.getters.getSessionFeedbacks
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/sessions/sessionshowfeedback";
</style>
